import React, { forwardRef, useState } from 'react';
import { Loader as DefaultLoader } from '../components/loader';
import { logError } from '../_shared/logger';

type TTouchableComponentProps = {
  onPress?: (...args: any[]) => Promise<void>;
  Loader?: React.ComponentType;
  enabledLoader?: boolean;
  [key: string]: any;
};
type TTouchableComponent = React.ComponentType<TTouchableComponentProps>;

export function withLoaderOnPress(TouchableComponent: TTouchableComponent) {
  return forwardRef(
    ({ onPress, Loader = DefaultLoader, enabledLoader = false, children, ...props }: TTouchableComponentProps, ref) => {
      const [isLoading, setIsLoading] = useState(false);

      const onPressHandler = async (...args: any[]) => {
        if (onPress) {
          setIsLoading(true);
          try {
            await onPress(...args);
          } catch (error) {
            logError(error, ...args);
          }
        }
        setIsLoading(false);
      };

      return (
        <TouchableComponent {...props} onPress={onPressHandler} ref={ref}>
          {enabledLoader && isLoading ? <Loader /> : children}
        </TouchableComponent>
      );
    },
  );
}
